import React from 'react'
import { Explore } from '../components/Explore'
import Header from '../components/Header'

export default function Explorepage() {
  return (
      <>
      <Header/>
      <Explore/>
      </>
  )
}
